import { Box, Typography } from "@mui/material";

const SectionHeading = ({ subtitle, mainTitle, highlight }) => {
  
    return (
    <Box sx={{ textAlign: "center", mb: 4 }}>
      <Typography
        variant="subtitle1"
        sx={{ color: "#FFC107", fontWeight: "bold", letterSpacing: "1px" }}
      >
        {subtitle}
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          textTransform: "uppercase",
          color: "#fff",
        }}
      >
        {mainTitle}{" "}
        <span style={{ color: "#FFC107" }}>{highlight}</span>
      </Typography>
    </Box>
  );
};

export default SectionHeading;
